module.exports = __webpack_public_path__ + "static/img/V-S30@2x.6764f2bc.png";